import { useMemo } from 'react';
import { ExtrudeGeometry } from 'three';
import { squareTubeProfile } from './crossSections';
import { SCALE_IN_TO_UNIT } from '../types';
import { MATERIALS } from '../materials';

interface Props {
  /** World position of base (foot) of the corner post — scene units */
  position: [number, number, number];
  /** Total post height in inches (typically railHeightIn 36 or 42) */
  heightIn: number;
  refId: string;
  partNumber?: string;
}

/**
 * Corner post = vertical 2"×2" square tube where two rail directions meet
 * at L90, U180 corners or wherever rails change direction. Ties rails
 * together visually (continuity) and structurally (real-life tie point).
 */
export function CornerPost({ position, heightIn, refId, partNumber = 'MTC120125125-POST' }: Props) {
  const VISUAL_SCALE = 3;
  const geometry = useMemo(() => {
    const g = new ExtrudeGeometry(squareTubeProfile(), { depth: heightIn, bevelEnabled: false });
    g.scale(SCALE_IN_TO_UNIT * VISUAL_SCALE, SCALE_IN_TO_UNIT * VISUAL_SCALE, SCALE_IN_TO_UNIT);
    g.rotateX(-Math.PI / 2); // extrusion Z → vertical Y
    return g;
  }, [heightIn]);
  return (
    <mesh
      geometry={geometry}
      material={MATERIALS.aluminumBrushed}
      position={position}
      castShadow
      receiveShadow
      userData={{ partNumber, kind: 'corner-post', refId, heightIn }}
    />
  );
}
